import type { BestellungAnsicht } from "../api";
import { euro } from "../geld";

interface Props {
  bestellung: BestellungAnsicht;
  onNeu: () => void;
}

/** Die Bestätigungsseite nach erfolgreicher Bestellung: Nummer, Status, Summe und ETA. */
export function Bestaetigung({ bestellung, onNeu }: Props) {
  return (
    <section className="bestaetigung">
      <h2>Danke! Deine Bestellung ist eingegangen.</h2>
      <dl className="bestell-details">
        <div>
          <dt>Bestellnummer</dt>
          <dd>{bestellung.id}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{bestellung.status}</dd>
        </div>
        <div>
          <dt>Kanal</dt>
          <dd>{bestellung.kanal === "LIEFERUNG" ? "Lieferung" : "Abholung"}</dd>
        </div>
        <div>
          <dt>Gesamtsumme</dt>
          <dd>{euro(bestellung.gesamtsummeCent)}</dd>
        </div>
        {bestellung.wartezeitMin != null && (
          <div>
            <dt>Voraussichtliche Wartezeit</dt>
            <dd>ca. {bestellung.wartezeitMin} Minuten</dd>
          </div>
        )}
      </dl>
      <p className="zart">Die Küche meldet sich, sobald die Bestellung angenommen ist.</p>
      <button type="button" className="knopf primaer" onClick={onNeu}>
        Neue Bestellung
      </button>
    </section>
  );
}
